/** @jsx h */
import { h } from 'preact'

export default ({ title, url, children }) => (
  <a
    className='db center mw5 tc black link dim bg-white mb3'
    title={title}
    href={url}
  >
    {children}
  </a>
)
